// 顯示/隱藏密碼區域
let isSlash = 1;

const inputPassword = document.querySelector(".password-area input");
const seeBtn = document.querySelector(".see-btn");

if (seeBtn) {
  seeBtn.addEventListener("click", function () {
    if (isSlash) {
      seeBtn.classList.add("no-slash");
      inputPassword.type = "text";
    } else {
      seeBtn.classList.remove("no-slash");
      inputPassword.type = "password";
    }
    isSlash = !isSlash;
  });
}
